import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
} from "../../../components/card/card";
import ImageViewer from "../../../components/ImageViewer";
import { printDate, printLocation } from "../../../utils/helper";
import React, { useState, useEffect } from "react";
import { companyProfile, role as roleAPI } from "../../../api";
import { parserAPI } from "../../../utils/parser";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import ModalChangeRole from "./modal/changeRoles";
import ConfirmationDlg from "../../../components/ConfirmationDlg";
import { PermissionChecker } from "../../../components/PermissionChecker";
import LoadingIndicator from "../../../components/LoadingIndicator";
function RolesConfiguration() {
  const [userRoles, setUserRoles] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [deleteRow, setDeleteRow] = useState(null);
  const [confirmDlg, setConfirmDlg] = useState(false);
  const [openDetail, setOpenDetail] = useState(false);
  const [data, setData] = useState([]);
  const [query, setQuery] = useState({ page: 1, take: 10, totalData: 1 });
  const [loading, setLoading] = useState(false);

  async function GetRoles() {
    try {
      setLoading(true);
      const res = await roleAPI.list(query);
      if (res.ok) {
        const body = await res.json();
        setData(body.data.results);

        if (body.data?.totalData) {
          setQuery((prev) => ({
            ...prev,
            totalData: data.totalData,
          }));
        }
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    GetRoles();
  }, [query.page, query.take]);
  async function deleteUserRoleConfirm(row) {
    setDeleteRow(row);
    setConfirmDlg(true);
  }
  async function deleteUserRole() {
    try {
      const response = await roleAPI.delete(deleteRow.id);
      if (response.ok) {
        const body = await response.json();
        //console.log({ body });
        if (body.success) {
          toast.success("This role has been deleted");
          setConfirmDlg(false);
          setDeleteRow(null);
        } else {
          toast.error(body.message);
        }

        GetRoles();
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }

  function addUserRole(value) {
    setOpenDetail(true);
  }
  function editUserRole(value) {
    setSelectedRow(value);
    setOpenDetail(true);
  }

  const columns = [
    {
      name: "Role Name",
      selector: (row) => row.name,
    },
    {
      name: "Description",
      selector: (row) => row.description,
    },
    {
      name: "Action",
      width: "150px",
      style: {
        paddingRight: "0",
      },
      cell: (row) => {
        return (
          <div>
            <button
              onClick={() => {
                editUserRole(row);
              }}
              className="btn btn-sm btn-outline-theme mx-1"
            >
              <i className="fa fa-edit"></i>
            </button>

            <PermissionChecker permissions={["delete role"]} hideIfNotAllowed>
              <button
                onClick={() => {
                  deleteUserRoleConfirm(row);
                }}
                className="btn btn-sm btn-outline-danger"
              >
                <i className="fa fa-trash"></i>
              </button>
            </PermissionChecker>
          </div>
        );
      },
    },
  ];
  async function onSubmit({
    name,
    permissions,
    description,
    accesses,
    service_groups,
  }) {
    let data = {
      name,
      description,
      permissions,
      accesses,
      service_groups,
    };

    setLoading(true);
    if (!selectedRow) {
      const response = await roleAPI.create(data);
      if (response.ok) {
        const body = await response.json();
        //console.log({ body });
        if (body.success) {
          //toast.success(body.message);
          toast.success("Role " + name + " is successfully added");
          setSelectedRow(null);
          setOpenDetail(false);
        } else {
          toast.error(body.message);
        }
      } else {
        toast.error("API Error");
      }
    } else {
      const response = await roleAPI.update(selectedRow.id, data);
      if (response.ok) {
        const body = await response.json();
        //console.log({ body });
        if (body.success) {
          //toast.success(body.message);
          toast.success("Role " + name + " is successfully updated");
          setSelectedRow(null);
          setOpenDetail(false);
        } else {
          toast.error(body.message);
        }
      } else {
        toast.error("API Error");
      }
    }
    GetRoles();
  }

  return (
    <div>
      <LoadingIndicator open={loading} />
      <ConfirmationDlg
        open={confirmDlg}
        onClose={() => {
          setConfirmDlg(false);
          setDeleteRow(null);
        }}
        onSubmit={deleteUserRole}
      >
        <div>Are you sure you want to delete this role?</div>
      </ConfirmationDlg>
      <ModalChangeRole
        onSubmit={onSubmit}
        open={openDetail}
        row={selectedRow}
        onClose={() => {
          setSelectedRow(null);
          setOpenDetail(false);
        }}
      ></ModalChangeRole>
      <div className="d-flex align-items-center mb-3">
        <div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="#/">Setup</a>
            </li>
            <li className="breadcrumb-item active">User Roles</li>
          </ol>
          <h1 className="page-header mb-0">User Roles</h1>
        </div>
      </div>

      <div className="row gx-4">
        <div className="col-lg-12 ">
          <div className="row justify-content-end">
            <div className="col-sm-3 mb-2 mb-sm-0">
              <PermissionChecker permissions={["create role"]} hideIfNotAllowed>
                <button
                  onClick={addUserRole}
                  className="btn btn-outline-theme w-100"
                >
                  Add Role <i className="bi bi-plus"></i>
                </button>
              </PermissionChecker>
            </div>
          </div>
          <Card className="mb-4 mt-2">
            <CardHeader>Update Role</CardHeader>
            <CardBody>
              <DataTable
                progressPending={loading}
                highlightOnHover
                theme="dark"
                columns={columns}
                data={data}
                pagination
                paginationServer
                onChangeRowsPerPage={(row) =>
                  setQuery((prev) => ({ ...prev, page: 1, take: row }))
                }
                paginationTotalRows={query.totalData}
                onChangePage={(page) =>
                  setQuery((prev) => ({ ...prev, page: page }))
                }
              />
            </CardBody>
          </Card>
        </div>
      </div>
    </div>
  );
}
export default RolesConfiguration;
